var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHowItWorks3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 456,
    height: 608,
    viewBox: "0 0 456 608",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1217_9708",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 456,
    height: 608
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 456,
    height: 608,
    rx: 40,
    fill: "#ECFFFA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1217_9708)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 456,
    height: 608,
    fill: "#ECFFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.74 318.407C124.08 302.053 138.265 286.88 161.168 275.41C218.28 246.847 307.795 252.23 361.083 287.433C382.439 301.541 394.631 318.321 397.974 335.172",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.735 261.313L193.639 157.484C192.24 156.662 190.781 157.027 189.595 157.545C188.288 158.093 184.608 160.314 184.608 160.314L188.227 167.465L188.348 320.622C188.348 325.491 191.359 331.212 195.038 333.312L371.181 440.428C371.181 440.428 376.198 437.841 377.809 436.898C379.421 435.955 380.181 433.885 380.181 431.268L380.485 274.033C380.485 269.164 377.475 263.443 373.796 261.313H373.735Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.9 440.307L188.805 336.477C185.308 334.469 182.48 329.052 182.48 324.427L182.358 165.488C182.358 160.832 185.186 158.702 188.652 160.71L368.748 264.539C372.245 266.548 375.073 271.964 375.073 276.59L375.194 430.873C375.194 435.529 372.367 442.345 368.9 440.337V440.307Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.336 422.2L194.186 324.67C192.666 323.787 191.419 321.444 191.419 319.405L191.298 178.177C191.298 176.138 192.514 175.225 194.034 176.107L363.184 273.638C364.704 274.52 365.951 276.863 365.951 278.902L366.073 420.131C366.073 422.17 364.856 423.082 363.336 422.2Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.622 400.807L208.844 320.227C207.598 319.497 206.564 317.549 206.564 315.875L206.473 199.174C206.473 197.5 207.476 196.739 208.753 197.439L348.53 278.02C349.777 278.75 350.811 280.697 350.811 282.371L350.902 399.073C350.902 400.746 349.899 401.507 348.622 400.807Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.284 215.667V337.207",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.958 282.371V380.51",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.016 261.069V358.995",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.751 303.612L240.741 240.164",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.751 327.713L240.741 264.265",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.751 352.331L240.741 288.914",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.751 376.98L240.741 313.562",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.407 223.792L213.771 213.628",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.924 264.844L286.288 254.68",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.407 248.441L213.771 238.277",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.407 259.639L213.771 249.476",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.407 270.838L213.771 260.674",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.407 282.066L213.771 271.872",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9672 269.163L103.154 247.915L115.871 254.705L122.051 219.411L128.642 216.195C132.79 213.803 135.344 209.378 135.344 204.567L145.369 166.744L138.228 163.418C136.772 162.594 134.987 162.594 133.531 163.418L58.9622 206.794C55.1994 208.993 52.9198 213.034 53.0022 217.377L53.7437 260.917C53.7712 263.006 54.8149 264.93 56.5452 266.112L60.9946 269.163H60.9672Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8552 269.769L114.332 241.814V252.919C114.332 254.733 116.721 255.393 117.655 253.826L130.289 232.605L140.369 226.723C144.517 224.332 147.071 219.906 147.071 215.096V170.044C147.071 166.91 143.693 164.958 140.974 166.525L66.4594 209.571C62.3121 211.962 59.7578 216.388 59.7578 221.198V266.278C59.7578 269.411 63.1361 271.363 65.8552 269.796V269.769Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.073 230.872L93.3779 224.275C92.0047 223.341 92.1145 220.619 93.5977 218.201C95.0808 215.782 97.3879 214.545 98.7337 215.479L103.623 218.805L112.659 200.444C113.922 197.915 116.229 196.32 117.795 196.87C119.36 197.447 119.58 199.949 118.317 202.505L104.776 229.828C104.337 230.68 103.54 231.175 103.073 230.872Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.537 347.447C392.432 364.154 379.418 380.343 357.434 393.489C302.612 426.232 212.944 427.541 157.179 396.41C134.831 383.934 121.421 368.11 116.83 351.555",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0305 405.488C71.634 394.448 77.2705 377.337 88.2483 370.809C90.3419 369.547 93.1602 367.881 94.7706 366.914L95.4685 359.581C94.8511 359.285 94.2338 358.936 93.6164 358.533L93.5359 358.479L93.2944 358.318C91.7645 357.297 90.6103 356.035 90.154 353.859L89.2683 350.018L86.2621 336.587C86.1548 336.157 86.0474 335.754 85.9669 335.297L85.8864 334.948C85.7253 333.927 85.618 332.853 85.5911 331.698C85.4569 319.905 93.5628 305.48 103.682 299.463C108.325 296.723 112.136 296.052 115.384 297.449L115.84 297.61L116.082 297.744C116.458 297.932 116.834 298.12 117.182 298.362L125.745 303.09L126.201 304.03L122.041 307.173C122.148 308.059 122.255 308.946 122.255 309.94C122.255 311.068 122.255 311.927 122.148 313.082L122.094 313.351L122.014 314.076C121.933 314.721 121.853 315.07 121.719 315.715L118.31 337.124C117.746 340.938 115.733 346.069 113.13 349.884L113.988 355.686C115.572 354.746 118.444 352.865 120.538 351.63C124.832 349.078 127.972 348.917 130.844 350.34L131.22 350.501L132.213 351.065C132.213 351.065 132.213 351.065 132.24 351.065L139.729 355.229L138.038 357.942C138.95 359.661 139.702 361.434 140.319 363.127C141.607 366.726 138.923 372.824 134.978 375.161L105.319 392.782L104.031 393.534L81.1088 407.154C80.8135 409.894 80.3304 413.6 80.0888 415.535C80.0083 416.152 79.3104 416.502 78.7736 416.179L70.4262 411.532C68.95 410.699 68.2521 408.497 68.95 405.515L69.0305 405.488Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2102 410.646C80.8138 399.605 86.4503 382.494 97.4281 375.967C99.5216 374.704 102.34 373.039 103.95 372.072L104.648 364.738C102.501 363.664 99.9511 362.106 99.3338 359.017L98.448 355.175L95.4419 341.744C95.3345 341.314 95.2272 340.912 95.1466 340.455L95.0661 340.106C94.9051 339.085 94.7977 338.01 94.7709 336.855C94.6367 325.063 102.743 310.638 112.861 304.621C122.98 298.604 131.328 303.278 131.462 315.07C131.462 316.198 131.462 317.058 131.355 318.213L131.301 318.482L131.22 319.207C131.14 319.852 131.059 320.201 130.925 320.846L127.516 342.255C126.953 346.069 124.94 351.2 122.336 355.014L123.195 360.816C124.779 359.876 127.651 357.996 129.744 356.76C140.749 350.233 146.734 360.413 149.552 368.257C150.841 371.857 148.157 377.954 144.211 380.291L114.552 397.913L113.264 398.665L83.6857 416.206C79.767 418.543 76.9487 415.696 78.1566 410.619L78.2102 410.646Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6182 333.283L86.316 325.305L95.5223 330.462L94.4755 335.996L98.5822 355.928L98.8506 356.089L99.8973 360.387L103.333 364.147L104.755 364.738L104.058 372.072L94.8513 366.914L95.5492 359.581L91.4157 357.217L89.9932 352.409L89.51 350.716L85.6182 333.283Z",
    fill: "#0F1936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4384 402.587L71.6079 397.322L69.219 403.903L68.8701 408.013L69.5948 411.183L78.9085 416.179L77.9959 412.311L79.8479 404.172L80.4384 402.587Z",
    fill: "#0F1936"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorks3);
export default __webpack_public_path__ + "static/media/howItWorks3.1e323b8d17dcf679a951456d5553303a.svg";
export { ForwardRef as ReactComponent };